import { helpers, numeric, required } from '@vuelidate/validators';
import ApplicationsResidence from './ApplicationsResidence';
import LOCALIZATION from '../Localization';
import moment from 'moment';
import { validDateOfBirth } from '@core/services/custom-validators';

export default class ApplicationsBusinessPrincipal {
	constructor(init) {
		this.principalSameAsApplicant = null;
		this.firstName = null;
		this.lastName = null;
		this.jobTitle = null;
		this.address = new ApplicationsResidence();
		this.phoneNumber = null;
		this.dateOfBirth = null;
		this.percentageOfOwnership = null;

		if (init) {
			this.principalSameAsApplicant = init.principalSameAsApplicant;
			this.firstName = init.firstName;
			this.lastName = init.lastName;
			this.jobTitle = init.jobTitle;
			this.address = new ApplicationsResidence(init.address);
			this.phoneNumber = init.phoneNumber;
			this.dateOfBirth = init.dateOfBirth ? moment(init.dateOfBirth, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]') : init.dateOfBirth;
			this.percentageOfOwnership = init.percentageOfOwnership;
		}
	}

	getFullName() {
		if (this.firstName && this.lastName) {
			return `${this.firstName} ${this.lastName}`;
		}
		return this.firstName || this.lastName || '';
	}

	getFormattedDateOfBirth() {
		return this.dateOfBirth ? moment(this.dateOfBirth).format('MMMM D, YYYY') : '';
	}

	getFormattedPercentageOfOwnership() {
		return this.percentageOfOwnership != null ? `${this.percentageOfOwnership}%` : '';
	}

	validation(language = 'English') {
		const requiredWithMessage = key => helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm[key][language], required);

		return {
			principalSameAsApplicant: {
				required: requiredWithMessage('principalSameAsApplicantRequired'),
			},
			firstName: { required: requiredWithMessage('firstNameRequired') },
			lastName: { required: requiredWithMessage('lastNameRequired') },
			jobTitle: { required: requiredWithMessage('jobTitleRequired') },
			phoneNumber: {
				numeric,
				required: requiredWithMessage('phoneNumberRequired'),
				validPhone: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidPhoneNumberFormat[language], value => value.length === 10),
			},
			dateOfBirth: {
				required: requiredWithMessage('dateOfBirthRequired'),
				validDateOfBirth: helpers.withMessage(LOCALIZATION.customerPortalAddBusinessForm.invalidDOBText[language], validDateOfBirth),
			},
			percentageOfOwnership: {
				required: requiredWithMessage('percentageOfOwnershipRequired'),
			},
			address: this.address.validation(false, language),
		};
	}
}
